
export class Branch {
  id: number;
  name: string;


  constructor(data: any = {}) {
    Object.assign(this, data);
  }

}
